"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTestDataAvatarsDto = instanceOfTestDataAvatarsDto;
exports.TestDataAvatarsDtoFromJSON = TestDataAvatarsDtoFromJSON;
exports.TestDataAvatarsDtoFromJSONTyped = TestDataAvatarsDtoFromJSONTyped;
exports.TestDataAvatarsDtoToJSON = TestDataAvatarsDtoToJSON;
exports.TestDataAvatarsDtoToJSONTyped = TestDataAvatarsDtoToJSONTyped;
const AvatarCredentials_1 = require("./AvatarCredentials");
/**
 * Check if a given object implements the TestDataAvatarsDto interface.
 */
function instanceOfTestDataAvatarsDto(value) {
    if (!('admins' in value) || value['admins'] === undefined)
        return false;
    if (!('nurses' in value) || value['nurses'] === undefined)
        return false;
    return true;
}
function TestDataAvatarsDtoFromJSON(json) {
    return TestDataAvatarsDtoFromJSONTyped(json, false);
}
function TestDataAvatarsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'admins': (json['admins'].map(AvatarCredentials_1.AvatarCredentialsFromJSON)),
        'nurses': (json['nurses'].map(AvatarCredentials_1.AvatarCredentialsFromJSON)),
    };
}
function TestDataAvatarsDtoToJSON(json) {
    return TestDataAvatarsDtoToJSONTyped(json, false);
}
function TestDataAvatarsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'admins': (value['admins'].map(AvatarCredentials_1.AvatarCredentialsToJSON)),
        'nurses': (value['nurses'].map(AvatarCredentials_1.AvatarCredentialsToJSON)),
    };
}
//# sourceMappingURL=TestDataAvatarsDto.js.map